import Flex from "app/components/Flex";
import React, { useRef, useState } from "react";

type SliderProps = {
  data: any;
  slideComponent: any;
  width: number;
  [x: string]: any;
};

export const Slide = ({
  data,
  slideComponent: SlideComponent,
  width,
  ...props
}: SliderProps) => {
  const [shouldDisableClick, setShouldDisableClick] = useState(false);
  const slideRef = useRef<any>(null);
  const mouseDownPosRef = useRef<{ x: number; y: number } | null>(null);
  const mouseDownTimeRef = useRef<number>(0);

  // Configure these values to adjust sensitivity
  const MOVEMENT_THRESHOLD = 5; // pixels
  const TIME_THRESHOLD = 200; // milliseconds

  const onMouseMove = (e: MouseEvent) => {
    if (!mouseDownPosRef.current || shouldDisableClick) {
      return;
    }

    const deltaX = Math.abs(e.clientX - mouseDownPosRef.current.x);
    const deltaY = Math.abs(e.clientY - mouseDownPosRef.current.y);
    const timeDelta = Date.now() - mouseDownTimeRef.current;

    // Only consider it a drag if:
    // 1. Movement is greater than threshold
    // 2. Time since mousedown is greater than threshold
    if (deltaX > MOVEMENT_THRESHOLD || deltaY > MOVEMENT_THRESHOLD) {
      if (timeDelta > TIME_THRESHOLD) {
        setShouldDisableClick(true);
      }
    }
  };

  const onClickEvent = () => {
    slideRef.current.onmousemove = null;
    mouseDownPosRef.current = null;
    setShouldDisableClick(false);
  };

  return (
    <Flex
      width={width}
      ref={slideRef}
      onMouseDown={(e: React.MouseEvent) => {
        mouseDownPosRef.current = { x: e.clientX, y: e.clientY };
        mouseDownTimeRef.current = Date.now();
        slideRef.current.onmousemove = onMouseMove;
      }}
      onMouseLeave={() => {
        slideRef.current.onmousemove = null;
        mouseDownPosRef.current = null;
        setShouldDisableClick(false);
      }}
      onClick={onClickEvent}
    >
      <SlideComponent
        {...props}
        key={data.id}
        data={data}
        shouldPropagateClickEvent
        disableClick={shouldDisableClick}
      />
    </Flex>
  );
};
